import type { ComponentType } from 'react'
import type { FieldType } from '../../types'
import type { FieldInputProps } from './types'
import { BooleanInput } from './inputs/BooleanInput'
import { CheckboxGroupInput } from './inputs/CheckboxGroupInput'
import { CurrencyInput } from './inputs/CurrencyInput'
import { DateInput } from './inputs/DateInput'
import { FileInput } from './inputs/FileInput'
import { GalleryInput } from './inputs/GalleryInput'
import { MultiSelectInput } from './inputs/MultiSelectInput'
import { NumberInput } from './inputs/NumberInput'
import { ReferenceInput } from './inputs/ReferenceInput'
import { RichTextInput } from './inputs/RichTextInput'
import { SelectInput } from './inputs/SelectInput'
import { SpecializedTextInput } from './inputs/SpecializedTextInput'
import { TextareaInput } from './inputs/TextareaInput'
import { TextInput } from './inputs/TextInput'

/**
 * FieldType minus typy prezentacyjne (SEPARATOR/SPACER/INSTRUCTION/HEADER). Te są
 * obsługiwane bezpośrednio w FieldRenderer.tsx, zanim dispatch zostanie wywołany.
 */
export type EditableFieldType = Exclude<FieldType, 'SEPARATOR' | 'SPACER' | 'INSTRUCTION' | 'HEADER'>

/**
 * EDIT-mode input per FieldType. {@code satisfies Record<EditableFieldType, ...>}
 * wymusza exhaustive map: dodanie typu do FieldType bez wpisu tutaj nie skompiluje TS.
 */
export const inputDispatch = {
  TEXT: TextInput,
  TEXTAREA: TextareaInput,
  RICH_TEXT: RichTextInput,
  NUMBER: NumberInput,
  CURRENCY: CurrencyInput,
  DATE: DateInput,
  BOOLEAN: BooleanInput,
  SELECT: SelectInput,
  MULTI_SELECT: MultiSelectInput,
  CHECKBOX_GROUP: CheckboxGroupInput,
  EMAIL: SpecializedTextInput,
  PHONE: SpecializedTextInput,
  URL: SpecializedTextInput,
  IBAN: SpecializedTextInput,
  NIP: SpecializedTextInput,
  PESEL: SpecializedTextInput,
  FILE: FileInput,
  GALLERY: GalleryInput,
  REFERENCE: ReferenceInput,
} satisfies Record<EditableFieldType, ComponentType<FieldInputProps>>
